"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.sortby")),
    _classnames = _interopRequireDefault(require("classnames")),
    _recentList = require("../styles/recentList"),
    _Icon = _interopRequireDefault(require("../../Icon")),
    _onEnterPressed = _interopRequireDefault(require("../../../common/utils/onEnterPressed")),
    ICON_SIZES = {
  square: 65,
  small: 25
},
    loadingElement = function loadingElement(a) {
  return _react["default"].createElement("div", {
    key: a.id,
    className: (0, _classnames["default"])("loading-wrapper", _recentList.LOADING_WRAPPER)
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loading-h1", _recentList.LOADING_H1)
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loading-p", (0, _recentList.LOADING_P)(135))
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loading-p", (0, _recentList.LOADING_P)(145))
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loading-p", (0, _recentList.LOADING_P)(140))
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("loading-p", (0, _recentList.LOADING_P)(150))
  }));
},
    getMostRecentItems = (0, _lodash["default"])(function (a) {
  var b = a.data,
      c = a.limit,
      d = void 0 === c ? 5 : c,
      e = (0, _lodash2["default"])(b, "updatedAt").reverse();
  return e.slice(0, d);
}),
    createBox = function createBox(a) {
  var b = a.onCreate,
      c = a.createText,
      d = a.size;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("create-wrapper", _recentList.CREATE_WRAPPER),
    onClick: b,
    onKeyPress: (0, _onEnterPressed["default"])({
      onClick: b
    }),
    role: "button",
    tabIndex: 0
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])("create-box", (0, _recentList.CREATE_BOX)(d))
  }, _react["default"].createElement(_Icon["default"], {
    name: "addthin",
    size: ICON_SIZES[d],
    color: "regent"
  }), "square" !== d && _react["default"].createElement("p", {
    className: (0, _classnames["default"])("create-text", _recentList.CREATE_TEXT)
  }, c || "Create New")), "square" === d && _react["default"].createElement("p", {
    className: (0, _classnames["default"])("create-text", _recentList.CREATE_TEXT)
  }, c || "Create New"));
};

function RecentList(a) {
  var b = a.data,
      c = a.renderElement,
      d = a.loading,
      e = a.onCreate,
      f = a.createText,
      g = a.size,
      h = void 0 === g ? "square" : g,
      i = a.limit,
      j = getMostRecentItems({
    data: b,
    limit: i
  });
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("recent-list", (0, _recentList.WRAPPER)(h))
  }, e && createBox({
    onCreate: e,
    createText: f,
    size: h
  }), j.map(d ? loadingElement : c));
}

RecentList.defaultProps = {
  loading: !1
};

var _default = (0, _react.memo)(RecentList);

exports["default"] = _default;